import { Fab, Tooltip } from '@mui/material';
import { MessageSquare } from 'lucide-react';
import { useUIStore } from '../../stores/useUIStore';
import { ICON_SIZES, ICON_STROKE } from '../../constants/icons';

export function AgentToggleButton() {
  const toggleAgentPanel = useUIStore((state) => state.toggleAgentPanel);

  return (
    <Tooltip title="Open your Chief of Staff" placement="left">
      <Fab
        color="primary"
        onClick={toggleAgentPanel}
        sx={{
          position: 'fixed',
          bottom: 24,
          right: 24,
          zIndex: 1000,
        }}
      >
        <MessageSquare size={ICON_SIZES.lg} strokeWidth={ICON_STROKE} />
      </Fab>
    </Tooltip>
  );
}
